import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { passwordService } from "../../../services/auth/password.service";
import { toast } from "react-hot-toast";
import { ArenaLogo } from "@/components/common/ArenaLogo";
const VerifyOTP: React.FC = () => {
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    } else {
      navigate("/affiliate/auth/forgot-password");
    }
  }, [location, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await passwordService.verifyOtp(email, otp, "affiliate");
      toast.success("OTP verified successfully");
      navigate("/affiliate/auth/reset-password", {
        state: { resetToken: response.resetToken },
      });
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : "Failed to verify OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className=" md:m-auto mx-auto w-[98%] md:w-1/4 pt-4 md:pt-0 md:h-max">
      <div className="  h-full mx-auto flex flex-col items-center justify-center   md:py-7 py-6 bg-card border border-border rounded-[24px] shadow-[1px_5px_10px_0px_#D1D1D11A,4px_18px_19px_0px_#D1D1D117,9px_41px_25px_0px_#D1D1D10D,15px_73px_30px_0px_#D1D1D103,24px_115px_33px_0px_#D1D1D100]  ">
         <ArenaLogo className="w-12 mb-8 border border-black mx-auto rounded-[12px] bg-[#f6f6f6]" />
      <div className="w-full flex items-center justify-center px-6">
        <div className="w-full">
        <div>
          <h2 className="font-bold text-[24px] text-foreground/60 leading-[24px] tracking-[0.16px] text-center align-middle">
            Verify OTP
          </h2>
          <p className="font-normal text-[14px] mt-4 tracking-normal text-center align-middle text-muted-foreground">
            Enter the OTP sent to your email address
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="otp" className="sr-only">
                OTP
              </label>
              <input
                id="otp"
                name="otp"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-border placeholder-gray-500 text-foreground rounded-t-md focus:outline-none focus:ring-brand-500 focus:border-brand-500 focus:z-10 sm:text-sm"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 
              border border-transparent text-sm font-medium rounded-md text-white
               bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
          </div>
        </form>
        </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOTP;
